/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Only run Sentry in production. On localhost/dev the 100% trace volume
// exhausted the ingestion quota → 429 responses logged to the console (a Best
// Practices ding) and polluted the prod Sentry project with dev data.
if (environment.production) {
  Sentry.init({
    dsn: "https://a4e1730e2d276efe5fbae5075669e03d@o4508162247557120.ingest.us.sentry.io/4508778642800640",
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session Replay removed: the @sentry-internal/replay chunk (~29KB) is no
      // longer loaded. Error tracking continues.
    ],
    // A tab still on the previous build asks for lazy chunks the deploy removed.
    // ChunkReloadErrorHandler reloads it onto the new build, so these are not
    // actionable, and right after a deploy they arrive in bursts large enough to
    // exhaust the Sentry quota (429s). Drop them at the source.
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to load module script',
      /Loading (CSS )?chunk/,
      'ChunkLoadError',
      'NG0750',
    ],
    // Tracing off: transactions were burning the shared quota (DEV-11772).
    tracesSampleRate: 0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/farmboxtx\.navego\.tech/,
      /^https:\/\/farmboxdelivery\.com/,
    ],
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
